import React, { useState } from 'react';
import { PaginatedTable, TableDataHeader, TableRow } from '@make-software/cspr-design';

import { StampActivityTableRow } from './stamp-activity-table-row';
import { PaginatedResponse } from '@/api';
import { StampAction } from '@/entities';
import { ApiRequestState } from '@/hooks';

export interface StampActivityTableProps {
  dataLoader: (page: number, perPage: number) => ApiRequestState<PaginatedResponse<StampAction>>;
}

interface PaginationState {
  page: number;
  perPage: number;
}

const ITEMS_PER_PAGE = 10;

export const StampActivityTable: React.FC<StampActivityTableProps> = ({ dataLoader }) => {
  const [{ page, perPage }, setPagination] = useState<PaginationState>({
    page: 1,
    perPage: ITEMS_PER_PAGE
  });

  const { loading, response, error } = dataLoader(page, perPage);

  return (
    <PaginatedTable
      loading={loading}
      // @ts-ignore
      data={response?.data}
      // @ts-ignore
      pageCount={response?.pageCount}
      itemCount={response?.itemCount}
      error={error}

      renderDataHeaders={() => (
        <TableRow>
          <TableDataHeader>Action</TableDataHeader>
          <TableDataHeader fixedWidthRem={10.25}>Amount</TableDataHeader>
          <TableDataHeader fixedWidthRem={8.25}>Time</TableDataHeader>
        </TableRow>
      )}
      renderPaginatedData={() => (response?.data || []).map((stampAction: StampAction) =>
        <StampActivityTableRow key={stampAction.transactionHash} stampAction={stampAction} />
      )}

      currentPage={page}
      setCurrentPage={(page) => setPagination({ page, perPage })}

      // @ts-ignore
      perPage={perPage}
      setPerPage={(perPage) => setPagination({ page, perPage })}
    />
  );
};
